import { render, staticRenderFns } from "./template_item.vue?vue&type=template&id=74402de4&scoped=true&"
import script from "./template_item.vue?vue&type=script&lang=js&"
export * from "./template_item.vue?vue&type=script&lang=js&"
import style0 from "./template_item.vue?vue&type=style&index=0&id=74402de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74402de4",
  null
  
)

export default component.exports